var _polygon, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAssistance(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-11"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--floor--inject-11",
    cx: 250,
    cy: 326.47,
    rx: 243.71,
    ry: 147.16,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Shadow--inject-11",
    d: "M20.2,337.13,237,462.31a9.32,9.32,0,0,0,8.42,0l114-65.82c2.33-1.35,2.33-3.52,0-4.87L142.64,266.44a9.34,9.34,0,0,0-8.43,0l-114,65.83C17.87,333.61,17.87,335.79,20.2,337.13Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-11",
    d: "M247.51,206.84c8.72,5.09,8.72,13.34,0,18.43s-22.85,5.09-31.57,0-8.72-13.34,0-18.43S238.79,201.75,247.51,206.84Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-11",
    d: "M458.34,274.11,321,194.8a5.44,5.44,0,0,0-5.07-.08L239.52,239c-1.41.82-1.41,2.13,0,2.95L272.58,261,244,280.28c-9.16,6.17-11.13,14.33-4.4,18.21s22.53,4.16,32.43-.74l32.77-18.18,13.72,7.92,58.1,33.58a5.68,5.68,0,0,0,5.11,0l76.62-44C459.71,276.31,459.73,275,458.34,274.11Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Mobile--inject-11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--mobile--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M347.63,394.21,246.83,452.4a10.82,10.82,0,0,1-10.51.19L33.39,335.42c-3.2-1.84-5.79-6-5.79-9.22s2.59-7.37,5.78-9.22l100.43-58a12.82,12.82,0,0,1,11.57,0L347.63,375.77c3.2,1.85,5.79,6,5.79,9.22S350.83,392.37,347.63,394.21Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.81,259,33.38,317c-3.19,1.85-5.79,6-5.78,9.22s2.59,7.38,5.78,9.22L236.32,452.59a11.07,11.07,0,0,0,5,1.25V314.41l-96-55.41A12.82,12.82,0,0,0,133.81,259Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.83,452.4l100.8-58.19c3.2-1.84,5.79-6,5.79-9.22s-2.59-7.37-5.79-9.22L241.35,314.41V453.84A10.66,10.66,0,0,0,246.83,452.4Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.44,442a11.33,11.33,0,0,1-10.21,0l-200.87-116c-4.32-2.5-4.32-6.58,0-9.07L133.8,259a12.84,12.84,0,0,1,11.58,0L347.62,375.77c3.19,1.84,3.19,4.85,0,6.68Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.44,442a11.33,11.33,0,0,1-10.21,0l-200.87-116c-4.32-2.5-4.32-6.58,0-9.07L133.8,259a12.84,12.84,0,0,1,11.58,0L347.62,375.77c3.19,1.84,3.19,4.85,0,6.68Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.68,430.35a12.12,12.12,0,0,1-11,0L50.84,330.56c-3-1.75-3-4.6,0-6.35l94.48-54.55a12.26,12.26,0,0,1,11,0l172.84,99.79c3,1.75,3,4.61,0,6.36Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.49,268.37a11.2,11.2,0,0,0-5.17,1.29L50.84,324.21c-3,1.75-3,4.6,0,6.35l18.73,10.81,80.92-51.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.39,273.79a12.24,12.24,0,0,0-11,0L50.9,328.34a5.71,5.71,0,0,0-1.43,1.15,5.48,5.48,0,0,0,1.37,1.07l172.84,99.79a12.12,12.12,0,0,0,11,0l94.49-54.54a5.81,5.81,0,0,0,1.42-1.14,5.51,5.51,0,0,0-1.36-1.09Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.39,273.79a12.24,12.24,0,0,0-11,0L50.9,328.34a5.71,5.71,0,0,0-1.43,1.15,5.48,5.48,0,0,0,1.37,1.07l172.84,99.79a12.12,12.12,0,0,0,11,0l94.49-54.54a5.81,5.81,0,0,0,1.42-1.14,5.51,5.51,0,0,0-1.36-1.09Z",
    style: {
      fill: "#fff",
      opacity: 0.75
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.37,298.7,102.12,289c1-.58,1-1.48.11-2a3.86,3.86,0,0,0-3.5.07L82,296.74c-1,.57-1,1.48-.11,2A3.89,3.89,0,0,0,85.37,298.7Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.13,282.12a1,1,0,0,0,0-2,3.75,3.75,0,0,0-3.39,0,1,1,0,0,0,0,2A3.75,3.75,0,0,0,114.13,282.12Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.92,278.19a1,1,0,0,0,0-1.95,3.71,3.71,0,0,0-3.4,0,1,1,0,0,0,0,1.95A3.71,3.71,0,0,0,120.92,278.19Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.61,309.55a1,1,0,0,0,0-2,3.75,3.75,0,0,0-3.39,0,1,1,0,0,0,0,2A3.75,3.75,0,0,0,66.61,309.55Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.4,305.63c.94-.55.94-1.42,0-2a3.75,3.75,0,0,0-3.39,0c-.94.54-.94,1.41,0,2A3.75,3.75,0,0,0,73.4,305.63Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97,365.54a3.86,3.86,0,0,1,1.81,3,1.14,1.14,0,0,1-.5,1.06c-.22.12-1,.61-1.27.73a1.29,1.29,0,0,1-1.3-.15L72.25,356.6a3.88,3.88,0,0,1-1.81-3,1.15,1.15,0,0,1,.45-1l1.31-.76a1.34,1.34,0,0,1,1.31.15Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97,365.54a3.86,3.86,0,0,1,1.81,3,1.14,1.14,0,0,1-.5,1.06c-.22.12-1,.61-1.27.73a1.29,1.29,0,0,1-1.3-.15L72.25,356.6a3.88,3.88,0,0,1-1.81-3,1.15,1.15,0,0,1,.45-1l1.31-.76a1.34,1.34,0,0,1,1.31.15Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.78,366.27,72.25,352.68c-1-.58-1.81-.17-1.81.91a3.88,3.88,0,0,0,1.81,3l23.53,13.58c1,.58,1.81.17,1.81-.91A3.86,3.86,0,0,0,95.78,366.27Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.78,366.27,72.25,352.68c-1-.58-1.81-.17-1.81.91a3.88,3.88,0,0,0,1.81,3l23.53,13.58c1,.58,1.81.17,1.81-.91A3.86,3.86,0,0,0,95.78,366.27Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.54,347.35a3.88,3.88,0,0,1,1.81,3,1.12,1.12,0,0,1-.5,1.06l-1.27.74a1.34,1.34,0,0,1-1.3-.15l-11.1-6.41a3.88,3.88,0,0,1-1.81-3,1.16,1.16,0,0,1,.46-1c.23-.14,1.08-.64,1.31-.76a1.33,1.33,0,0,1,1.31.14Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.54,347.35a3.88,3.88,0,0,1,1.81,3,1.12,1.12,0,0,1-.5,1.06l-1.27.74a1.34,1.34,0,0,1-1.3-.15l-11.1-6.41a3.88,3.88,0,0,1-1.81-3,1.16,1.16,0,0,1,.46-1c.23-.14,1.08-.64,1.31-.76a1.33,1.33,0,0,1,1.31.14Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.28,348.08l-11.1-6.41c-1-.57-1.81-.16-1.81.92a3.88,3.88,0,0,0,1.81,3L64.28,352c1,.57,1.81.16,1.81-.92A3.86,3.86,0,0,0,64.28,348.08Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.28,348.08l-11.1-6.41c-1-.57-1.81-.16-1.81.92a3.88,3.88,0,0,0,1.81,3L64.28,352c1,.57,1.81.16,1.81-.92A3.86,3.86,0,0,0,64.28,348.08Z",
    style: {
      opacity: 0.30000000000000004
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Keyboard--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-11",
    d: "M154.4,375.62l26.15,15.16a3.12,3.12,0,0,0,2.85,0l75.06-43.27a.87.87,0,0,0,0-1.65L232.31,330.7a3.15,3.15,0,0,0-2.85,0L154.4,374A.87.87,0,0,0,154.4,375.62Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--keyboard--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M255.4,343.63a1,1,0,0,0-.58-.81l-23.39-13.5a3.05,3.05,0,0,0-2.79,0L157.25,370.6a1,1,0,0,0-.58.81v2.45a1,1,0,0,0,.58.81l23.39,13.5a3.11,3.11,0,0,0,2.79,0L254.82,347a1,1,0,0,0,.58-.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.64,385.65l-23.39-13.44a.85.85,0,0,1,0-1.61l71.39-41.28a3.05,3.05,0,0,1,2.79,0l23.39,13.5a.85.85,0,0,1,0,1.61l-71.39,41.22A3.05,3.05,0,0,1,180.64,385.65Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.94,386v2.51a2.82,2.82,0,0,1-1.31-.32l-23.37-13.5a1,1,0,0,1-.58-.81V371.4a1,1,0,0,0,.58.81l23.37,13.45A3,3,0,0,0,181.94,386Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.86,331.45h0l2.32,1.33-3.14,1.82-2.4-1.35,3.14-1.81Zm3.63,2.09h0l2.31,1.34-2.46,1.42L231,335l2.47-1.43Zm-8,.44h.05l2.32,1.34-2.47,1.42L223,335.41l2.46-1.43Zm11.64,1.65h0l2.32,1.34-4,2.3-2.39-1.34,4-2.3Zm-7.34.05h0l2.32,1.34-2,1.13-2.39-1.34,2-1.13Zm-8,.45h.05l2.32,1.33-2.47,1.43-2.39-1.35,2.46-1.42Zm4.8,1.41h.06l2.31,1.33L227,340l-2.39-1.34,2-1.13Zm14.18.19h0l2.31,1.33L240,340.89l-2.39-1.35,3.14-1.81Zm-22.69.54h0l2.31,1.34-17.82,10.29-2.4-1.35L218,338.27Zm13.83.38h.05l2.32,1.34-2,1.13-2.4-1.34,2-1.13Zm-8.52.74h0l2.32,1.33-2,1.13-2.4-1.34,2-1.13Zm21,.43h0l2.32,1.34-2,1.13-2.4-1.35,2-1.13Zm-8,.44h.05l2.31,1.34-2,1.13-2.39-1.35,2-1.13Zm-7.68.25h.05l2.32,1.33-2,1.13-2.4-1.34,2-1.13Zm-8.52.73h0l2.32,1.34-2,1.13-2.4-1.35,2-1.13Zm21,.43h.06l2.31,1.34-2,1.13-2.39-1.35,2-1.13Zm-8,.44h.05l2.32,1.34-2,1.13-2.4-1.35,2-1.13Zm-7.68.25h.06l2.31,1.33-2,1.13-2.39-1.34,2-1.13Zm23.3,0h.05l2.32,1.33-2.47,1.43-2.39-1.35,2.46-1.42Zm-31.82.73H217l2.31,1.34-2,1.13L215,344.22l1.95-1.13Zm21,.43H238l2.31,1.34-2,1.13L236,344.65l2-1.13Zm-8,.44h0l2.32,1.34-2,1.13L228,345.1l2-1.13Zm-7.67.25h.05l2.31,1.34-2,1.13-2.39-1.35,2-1.13Zm-8.52.73h0l2.31,1.34-2,1.13-2.39-1.35,2-1.13Zm29.91.37h0l2.32,1.33-2,1.14-2.4-1.35,2-1.13Zm-8.91.06h0l2.32,1.34-2,1.13-2.4-1.34,2-1.13Zm-8,.44h.06l2.31,1.34-2,1.13L224.74,347l2-1.13Zm-7.67.25h0l2.32,1.34-2,1.13-2.4-1.35,2-1.13Zm-8.52.73h.05l2.32,1.34-2,1.13-2.4-1.34,2-1.13Zm29.91.37h.06l2.31,1.34-2,1.13-2.39-1.35,1.95-1.13Zm-8.91.06h.05l2.32,1.34-2,1.13-2.4-1.34,2-1.13Zm-8,.45h0l2.32,1.33-2,1.13-2.4-1.34,2-1.13Zm-7.68.24h0l2.32,1.34-2,1.13L213.86,349l1.95-1.13Zm-8.52.74s.05,0,.05,0l2.32,1.33-2,1.13-2.39-1.34,1.95-1.13Zm29.92.36h0l2.31,1.34-2,1.13-2.39-1.35,2-1.13Zm-8.92.07h.06l2.31,1.33-2,1.13-2.39-1.34,2-1.13Zm-29.35.2H199l2.32,1.34-2.47,1.42-2.39-1.34,2.46-1.43Zm21.34.24h.05l2.32,1.33-2,1.14-2.4-1.35,2-1.13Zm-7.67.24h.05l2.31,1.34-2,1.13-2.39-1.34,2-1.13Zm-8.52.74h0l2.31,1.33-2,1.13-2.39-1.34,2-1.13Zm29.91.36h.05l2.32,1.34-2,1.13L232,352l2-1.13Zm-8.91.07h0l2.32,1.33-2,1.14-2.39-1.35,2-1.13Zm-8,.44h.06l2.31,1.34-2,1.13-2.39-1.35,2-1.13Zm-21.84.06h.05l2.32,1.33-2.47,1.43-2.39-1.35,2.46-1.42Zm14.17.18s0,0,0,0L211.8,353l-2,1.13-2.4-1.34,2-1.13Zm-8.52.74H201l2.32,1.34-2,1.13-2.4-1.35,2-1.13Zm21,.43H222l2.32,1.34-2,1.13-2.4-1.35,2-1.13Zm-8,.44h0l2.32,1.34-2,1.13-2.39-1.35,2-1.13Zm-7.68.25h.05l2.32,1.33-2,1.13-2.4-1.34,2-1.13Zm23.21,0h0l2.31,1.34-2,1.13-2.39-1.35,2-1.13Zm-37.88.05h0l2.31,1.34-2.46,1.42-2.4-1.35,2.47-1.42Zm6.15.63h.05l2.32,1.34-2,1.13-2.39-1.35,1.95-1.13Zm21,.43h.06l2.31,1.34-2,1.13-2.39-1.35,1.95-1.13Zm-8,.44h.05l2.32,1.34-2,1.13-2.4-1.35,2-1.13Zm-7.68.25h.06l2.31,1.34-2,1.13L201,356.45l2-1.13Zm23.21.05h.05l2.32,1.34-2,1.13-2.4-1.35,2-1.13Zm-38.39.34h0l2.32,1.34-3.14,1.81-2.4-1.34,3.14-1.81Zm6.66.34h.06l2.31,1.34L190.68,361l-2.39-1.35,6.18-3.57Zm21,.43h.05l2.31,1.34-2,1.13-2.39-1.35,2-1.12Zm-8,.44h.06l2.31,1.34-2,1.13-2.39-1.34,1.95-1.13Zm-7.67.25h.05l2.32,1.34-2,1.13-2.4-1.35,2-1.13Zm23.2.05h.05l2.32,1.34-2,1.13L221,358.36l1.95-1.13Zm-10.72,1.11h.05l2.32,1.34-2,1.13-2.4-1.34,2-1.13Zm-29.52.31h0l2.32,1.33-2,1.13-2.4-1.34,2-1.13Zm21.51.14h.05l2.31,1.33-2,1.13-2.39-1.34,2-1.13Zm-7.68.24h.05l2.32,1.34-1.79,1a.38.38,0,0,0-.2.33.38.38,0,0,0,.21.34l3,1.75-2.3,1.33-6-3.44,4.66-2.69Zm23.21.05h.05l2.31,1.34-2,1.13-2.39-1.34,2-1.13Zm-10.73,1.12h0l2.32,1.33-2,1.13-2.39-1.34,2-1.13Zm-29.52.3h.05l2.32,1.33L180,363l-2.39-1.35,1.95-1.13Zm21.51.14h.05l2.32,1.33-2,1.13-2.4-1.34,2-1.13Zm14.13,1.1h.06l2.31,1.34-2,1.13-2.39-1.35,1.95-1.13Zm-9.32.31h.05l2.31,1.33-2,1.14-2.39-1.35,2-1.13Zm-29.53.3h.06l2.31,1.34-2,1.13-2.39-1.35,2-1.13Zm6.84.24h.05l2.31,1.34-2,1.13-2.39-1.35,2-1.13Zm28.81,1h.05l2.31,1.34-2,1.13L210,364.72l2-1.13Zm-9.33.31h.05l2.32,1.33-3.48,2-2.4-1.34,3.48-2Zm-30.2.69h.05l2.32,1.34-5.17,3-2.39-1.35,5.16-3Zm21.17.33h.06l2.31,1.34-2,1.13-2.39-1.34,2-1.13Zm15.15.53h.05l2.32,1.34-2,1.13-2.4-1.34,2-1.13Zm-32.69,1.23h.05l2.31,1.34-2,1.13-2.39-1.34,2-1.13Zm14.34.1h.05l2.31,1.33-2,1.13-2.39-1.34,2-1.13Zm6.83.24h0l2.32,1.33-2,1.14-2.4-1.35,2-1.13Zm8.31.28h0l2.32,1.33-2,1.13-2.39-1.34,2-1.13Zm-39.52,1h.05l2.32,1.34-2,1.13-2.4-1.34,2-1.13Zm6.83.25s.05,0,.05,0l2.32,1.33-2,1.13-2.4-1.34,2-1.13Zm14.34.09h.05L189.6,370l-2,1.14-2.4-1.35,2-1.13Zm-7.51.15h.05l2.32,1.33-2,1.13-2.39-1.34,1.95-1.13Zm14.34.09h.05l2.32,1.34-2,1.13-2.4-1.35,2-1.13Zm7.61.69h.05l2.31,1.33-2,1.14-2.39-1.35,2-1.13Zm-38.82.59h.05l5.94,3.42-2,1.14-6-3.44,2-1.13Zm6.83.24h.06l2.31,1.33-2,1.14-2.39-1.35,2-1.13Zm6.83.24h.06l2.31,1.33-2,1.14-2.39-1.35,2-1.13Zm14.34.09h.06l2.31,1.34-2,1.13-2.39-1.35,1.95-1.13Zm-7.5.15h.05l2.31,1.34-2,1.13L181.36,372l2-1.13Zm15.11.54h0l2.32,1.34-2,1.13-2.4-1.35,2-1.13Zm-25.15,1.07h.05l2.32,1.34-2,1.13-2.4-1.35,2-1.13Zm6.83.24h.05l2.32,1.34-2,1.13-2.4-1.35,2-1.13ZM187,373H187l2.32,1.34-2,1.13-2.4-1.35,2-1.13Zm8.28.3h.05l2.32,1.34-2,1.13-2.39-1.35,1.95-1.13Zm-25.15,1.07h.05l5.94,3.43-2,1.13-6-3.44,2-1.13Zm6.83.24h0l2.32,1.34-2,1.13L175,375.69l2-1.12Zm6.83.24h.05l2.32,1.34-2,1.13-2.39-1.34,2-1.13ZM192.3,376h0l1,.57-2,1.13-1.08-.58,2-1.13Zm-11.74.62h.05l2.31,1.34-2,1.13-2.39-1.34,2-1.13Zm8.53,1.23h.06l1,.57-2,1.13-1.07-.58,1.94-1.13Zm-11.74.63h.05l2.32,1.33-2,1.13-2.4-1.34,2-1.13Zm8.54,1.22h.05l1,.57-2,1.13-1.07-.58,2-1.12Zm-3.21,1.85h0l1,.57-2,1.13-1.08-.58,2-1.12Z",
    style: {
      fill: "#06EB83"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-11",
    d: "M96,347.28c1.08,2.73,3.41,4.15,6.86,5.69,10.1,4.55,34.31,10,47.9,12.42,7.91,1.41,16,4,24.08,4.35,7.23.29,14.73-1,20.73-5.08a4.5,4.5,0,0,0,1.94-2.11,3.41,3.41,0,0,0-1.69-3.75,10.19,10.19,0,0,0-4.27-1.13,174.21,174.21,0,0,1-46.81-12.41c6.71-.71,13.53-1.44,19.77-4s12-7.23,14.16-13.61c.44-1.28.8-2.7,1.86-3.55a4.3,4.3,0,0,1,4.08-.38c4.39,1.57,6.13,6.71,7.43,11.19s3.46,9.59,8,10.62c-1.65-1-1-3.86.74-4.55s3.87.39,4.93,2,1.33,3.44,2.21,5.07,2.77,3,4.48,2.33a4.23,4.23,0,0,0,2-2.14c2.42-4.73,2-10.56-.14-15.43s-5.73-8.95-9.57-12.62c-5.35-5.11-11.37-9.7-18.3-12.3-14.5-5.45-30.81-1.48-45.18,4.32a187.77,187.77,0,0,0-31.09,16.05,52.11,52.11,0,0,0-10.24,8c-2.19,2.34-4.49,5.66-4.26,9A6.82,6.82,0,0,0,96,347.28Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Arm--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M218.9,331.71c-2.12-3.28-5.92-10-7.11-11.38-3.25-3.7-9.95-9.55-9.95-9.55-6.32-5.15-25.73-22.29-25.73-22.29s-3-38-6.36-44.08c-3.88-7.08-11.26-7.37-18.9-7.83,0,0-2,8.25-2.78,15,0,0,6.87,42.62,7.69,46.58s2.83,5.7,6.92,8.33c6.25,4,28.86,16.15,28.86,16.15l1.11.77a4.44,4.44,0,0,1,1.64,2.18,12.86,12.86,0,0,1,.59,2.7c.36,3.15,0,4,.27,7.44s1,3.33,2.35,6.28c1.21,2.73,1.57,4.44,2.57,4.54s2.28-2.12,2.28-4.37-1.37-4.73-1.42-5.68.45-2.13,2.59-.87,4.14,5.09,5.73,7.74,2.44,6.15,4.05,8.06,2.21-.21,2.95-2,4.35-4.71,5.3-7.57S221,335,218.9,331.71Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.85,236.34c5.26,0,9.53-.58,14.16,2.24s5.88,6.68,6.93,12.68c.95,5.46,2.88,24.26,2.88,24.26s-13.36,7.37-25,2.67Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.75,339.19h0l0,0Z",
    style: {
      fill: "#06EB83"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M161.91,210.56a29.68,29.68,0,0,1,6.34,2.94,5.59,5.59,0,0,1,1.93,7.58l-2.41-.48s1.24-2.83-.21-4.34-5.69-2.82-5.69-2.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.18,219.51c-2-.95-2.9.27-4.28,3.59s-.43,4.23,1.25,4.89,3-.45,4-3.2C171.31,221.7,171.28,220.54,169.18,219.51Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.34,219.54c-2-.95-2.9.27-4.28,3.59s-.43,4.23,1.25,4.89,3-.45,4-3.2C171.48,221.73,171.45,220.57,169.34,219.54Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--Chest--inject-11",
    d: "M129.15,238.76c-11,2.47-22.82,6-31.68,9.85,0,0-.71,37.91,5.43,56s4.37,38.7,4.37,38.7c30,4.85,66.39-9.09,65.49-24.21A67,67,0,0,0,167.7,310s-.75-12.15-.42-17.56c22-20.59-8.55-47-16.43-56.06C146.05,237,139,236.55,129.15,238.76Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.34,183.05c-1.42,2.55-.83,5.56-.25,8.26.45,2.06,1.68,4.61,1.16,6.7a13.55,13.55,0,0,1-5,7.18,14.68,14.68,0,0,1-1.89,1.34c-.57.31-1.23.45-1.81.77a8.11,8.11,0,0,0-2.95,3,22.62,22.62,0,0,0-2.14,5.68,19.81,19.81,0,0,1-2.25,5.63,11.64,11.64,0,0,1-10.34,4.89,14,14,0,0,1-6.23-2,16.51,16.51,0,0,1-2.67-2,6.77,6.77,0,0,1-1.76-2.34,11.28,11.28,0,0,0,1.88,7.57,13.26,13.26,0,0,1-15.45-14.87c.36-2.56,1.45-5,2-7.49,1.52-6.8-4.58-10.52-5.58-16.72a9.61,9.61,0,0,1,4.9-9.8c2.09-1.1,4.84-1.65,5.71-3.84.67-1.68-.15-3.55-.12-5.36,0-3.58,3.38-6.31,6.78-7.39s7.09-1.07,10.52-2.09c3.66-1.08,7-3.31,10.72-4a13.82,13.82,0,0,1,12.2,4.16c1.41,1.5,2.18,3.25,3.43,4.8s3.16,2.35,4.08,4.17a8.41,8.41,0,0,1,.26,7.74C131.29,179.43,128.64,180.74,127.34,183.05Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.17,191.13c-.42-11.9-7.33-28.88-32.9-26.71-24.92,2.12-32.25,24.35-30,36.42,3.17,16.66,15.29,17.73,18.44,28.62Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.44,200.23a6,6,0,0,1,6.26-2.08,6.18,6.18,0,0,1,3.08,2c1.15,1.27,1.13,3,1.94,4.45a3.29,3.29,0,0,0,2.44,1.77c3.43.31,2.15-5.26,2.34-7.24,6.48-2.3,6.3-4.7,7.18-10.42,4.54-4.9,12.42-5.62,19.24-.93,4.16-8,8.67-7,10.62-4.53a32,32,0,0,1,2.91,9.31,61.93,61.93,0,0,1,1.09,14.69c-.84,19.11-7.14,23.7-10.28,25s-7,.36-12.77-.73V243c6,11.45,10.79,28.78,10.56,40.1-9.23-17.48-23.68-26.83-30.51-33.18a26.13,26.13,0,0,1-4.13-4.76V215s-2.52,2.69-6.52-.49C103.54,210.23,101.9,204.23,105.44,200.23Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.49,231.54c-5-1.3-10.35-3.19-14-6a17.28,17.28,0,0,1-5.42-7.61s.43,7.37,4.14,10.69,15.32,7.15,15.32,7.15Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.27,204.9a2.65,2.65,0,1,1-3-2.37A2.7,2.7,0,0,1,140.27,204.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.05,202.57a2.43,2.43,0,0,1-2,2.79,2.3,2.3,0,0,1-2.72-2.15,2.4,2.4,0,1,1,4.76-.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "145.82 199.26 147.7 215.18 155.88 212.06 145.82 199.26",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.85,196.87l-6,2.74a3.44,3.44,0,0,1,1.67-4.47A3.22,3.22,0,0,1,138.85,196.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.92,217.18l8.61,2.92a4.77,4.77,0,0,1-5.94,2.9A4.44,4.44,0,0,1,136.92,217.18Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.13,219.19a4.47,4.47,0,0,1,4.22,4,4.45,4.45,0,0,1-1.76-.22,4.32,4.32,0,0,1-2.9-3.74A3.11,3.11,0,0,1,137.13,219.19Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.82,197.56l-6.06-2.66a3.17,3.17,0,0,1,4.26-1.77A3.48,3.48,0,0,1,159.82,197.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.49,235.21c3.86,1.12,15.14,16.38,18.8,21.88l-4.14,10.56a48.76,48.76,0,0,1,6.53,8.43l-8.43,24.55s.76-32.71-12.76-57.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.13,281.91c3,7.79,3.42,25.85,3.42,25.85s-3-16.85-17.17-22.75c0-.81.15-12.35.15-12.35s-19-4.82-23-6.63l-4.09-22s2.73-6.82,5-7v4.75a221,221,0,0,1,17.93,15.78C143.73,267.55,148.15,274.12,151.13,281.91Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.25,359.57c-3.06-2.57-7.49-6.13-11-7a19.87,19.87,0,0,0-2.49-.55,26.69,26.69,0,0,0,3.49-1,6.34,6.34,0,0,0,2.84-2.24c.26-.41.42-1,0-1.32a.84.84,0,0,0-.51-.14c-2.59.13-4.66-.1-7-.08a10.12,10.12,0,0,0-3.16.32c-.94.35-1.88.71-2.8,1.11-4.17,1.84-8,3.5-14.16,2.59l-2.58-.68-43.38-22.35-8.23-44.8s-2-27.78-13.25-34.52c-6,2.28-12.57,7.92-14.35,14-2.1,7.23-1.28,17.5,2.3,33.43,3,13.33,6.13,27,9.52,37.15s4.69,13.74,11.35,15.73c11.17,3.34,51.47,14.39,51.47,14.39a26.48,26.48,0,0,0,2.52.83c1.39.39,2.69,1.35,6,2.07,3.93.86,8.71-.93,12-1.39s9.07.62,12.26,1.62,6.5-4.06,8.09-3.61S203.32,362.15,200.25,359.57Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.14,350.32a11.75,11.75,0,0,0-4.65,1.15,25.82,25.82,0,0,1,6.23.56,26.69,26.69,0,0,0,3.49-1,6.69,6.69,0,0,0,2.59-1.89C191,350.56,187.4,350.36,185.14,350.32Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.47,248.61c-7.77,3.32-12.92,7.38-15,15.93s-.61,16.06,1.14,25.11,5.85,23.76,5.85,23.76,16.63,1,26.22-5.65l-5.25-34.12S107.66,253.38,98,248.92",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.84,168.39c-5.84,5.41-11.44,13.08-7.29,30.83a9.63,9.63,0,0,0-2.41,10c1.6,5.48,6.86,9.09,11.75,8s7.54-6.31,5.94-11.8c-1.21-4.1-5.61-8.07-9.23-7.81,0,0-3.47-7.59-.22-18.35,4.44-14.66,21.53-15.88,29.05-14.69C135.91,161,118.56,161.24,110.84,168.39Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.84,168.39c-5.84,5.41-11.44,13.08-7.29,30.83a9.63,9.63,0,0,0-2.41,10c1.6,5.48,6.86,9.09,11.75,8s7.54-6.31,5.94-11.8c-1.21-4.1-5.61-8.07-9.23-7.81,0,0-3.47-7.59-.22-18.35,4.44-14.66,21.53-15.88,29.05-14.69C135.91,161,118.56,161.24,110.84,168.39Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.87,205.23c-1.78-6.08-7.61-10.07-13-8.93a8.27,8.27,0,0,0-2.35.88c-.61.34-2.45,1.6-2.81,1.84-3.46,2.29-5,7-3.63,11.84,1.78,6.08,7.61,10.07,13,8.93a8.47,8.47,0,0,0,2.8-1.14c.44-.28,2.16-1.43,2.58-1.73C119.77,214.59,121.26,210,119.87,205.23Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.87,205.23c-1.78-6.08-7.61-10.07-13-8.93a8.27,8.27,0,0,0-2.35.88c-.61.34-2.45,1.6-2.81,1.84-3.46,2.29-5,7-3.63,11.84,1.78,6.08,7.61,10.07,13,8.93a8.47,8.47,0,0,0,2.8-1.14c.44-.28,2.16-1.43,2.58-1.73C119.77,214.59,121.26,210,119.87,205.23Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.66,206.71c-1.78-6.07-7.61-10.07-13-8.92s-8.36,7-6.58,13.07,7.61,10.07,13,8.93S119.44,212.79,117.66,206.71Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.66,206.71c-1.78-6.07-7.61-10.07-13-8.92s-8.36,7-6.58,13.07,7.61,10.07,13,8.93S119.44,212.79,117.66,206.71Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.49,207.81c-.84-2.87-3.6-4.75-6.15-4.21s-4,3.3-3.11,6.17,3.6,4.75,6.15,4.21S113.33,210.67,112.49,207.81Z",
    style: {
      fill: "#37474f"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Monitor--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-11",
    d: "M231.75,422.84,211.53,411a1,1,0,0,1,0-2l79.29-45.78a3.69,3.69,0,0,1,3.36,0l20.2,11.75a1,1,0,0,1,0,1.94L235.1,422.85A3.67,3.67,0,0,1,231.75,422.84Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--monitor--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M305.54,356.14l5.31-63a5.39,5.39,0,0,0-2.36-4.72,6,6,0,0,0-5.4.1l-79.2,45.73a6.91,6.91,0,0,0-3.06,4.82l-5.3,63a5.35,5.35,0,0,0,2.35,4.72,6,6,0,0,0,5.41-.1L302.49,361A6.87,6.87,0,0,0,305.54,356.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.84,293.13l-5.3,63,3.85-62.54c.14-1.77-.5-2.44-2-1.56l-78.23,45.21a6.31,6.31,0,0,0-2,2.05l-5.23-3a6.12,6.12,0,0,1,2-2l79.19-45.73a6.05,6.05,0,0,1,5.42-.1A5.38,5.38,0,0,1,310.84,293.13Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.76,405.09l5.31-63a6.87,6.87,0,0,1,3.05-4.82L307.35,292c1.54-.89,2.18-.21,2,1.56l-3.85,62.54a6.87,6.87,0,0,1-3.05,4.83l-79.2,45.72C221.75,407.58,220.62,406.87,220.76,405.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "259.67 367.01 259.06 385.99 281.06 373.34 275.7 357.8 259.67 367.01",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "262.88 369.1 278.24 360.18 275.62 358.67 260.27 367.6 262.88 369.1",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.64,386.83l-8.4-26.65-15.36,8.93-2.6-1.52L262,388.11l.43,5.9.25,1.26-1.12-.64-5-2.86a.84.84,0,0,0-.75-.1h0a.77.77,0,0,0-.35.73v.45a2.4,2.4,0,0,0,1.08,1.9l0,0,8.22,4.75h0a2.4,2.4,0,0,0,1,.26,2.3,2.3,0,0,0,1.19-.27l18.71-10.8A1.93,1.93,0,0,0,286.64,386.83Zm-11.81-2.28a3.23,3.23,0,0,1-5-2,6.19,6.19,0,0,1,2.75-6.54,3.21,3.21,0,0,1,5,2A6.18,6.18,0,0,1,274.83,384.55Z",
    style: {
      fill: "#37474f"
    }
  }), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "255.83 391.68 262.21 388 263.5 396.58 255.83 391.68"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M262.88,369.11l-2.61-1.51L262.43,394c.14.7-.26,1-.86.62l-5-2.86c-.61-.36-1.1-.06-1.1.64v.44a2.42,2.42,0,0,0,1.06,1.91s0,0,0,0l8.24,4.75h0a2.3,2.3,0,0,0,1,.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.83,384.55a3.21,3.21,0,0,1-4.18-.45,3.65,3.65,0,0,0,2.33-.54,6.16,6.16,0,0,0,2.75-6.53,3.82,3.82,0,0,0-.83-1.59,3.26,3.26,0,0,1,2.67,2.57A6.18,6.18,0,0,1,274.83,384.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.67,344.45l-1,12.15c-.07.8.37,1.17,1,.82a2.88,2.88,0,0,0,1.22-2.07l1-12.14c.07-.81-.37-1.17-1-.83A2.93,2.93,0,0,0,261.67,344.45Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.61,342.18l-1,12.14c-.07.8.37,1.17,1,.83a2.92,2.92,0,0,0,1.22-2.08l1-12.14c.07-.8-.37-1.17-1-.82A2.91,2.91,0,0,0,265.61,342.18Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.55,339.9l-1,12.15c-.07.8.37,1.17,1,.82a2.88,2.88,0,0,0,1.22-2.07l1-12.14c.07-.81-.37-1.17-1-.83A2.93,2.93,0,0,0,269.55,339.9Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.49,337.63l-1,12.14c-.06.8.37,1.17,1,.83a2.92,2.92,0,0,0,1.22-2.08l1-12.14c.07-.8-.37-1.17-1-.82A2.91,2.91,0,0,0,273.49,337.63Z",
    style: {
      fill: "#06EB83"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pot--inject-11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--pot--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M219.75,218.07c-6.4-6.61-10.17-33.51-3.92-38.76h31.79c6.25,5.24,2.49,32.14-3.91,38.75l-.18.18-.22.22a7.37,7.37,0,0,1-.58.52l-.15.12c-.16.13-.31.25-.48.37a9.75,9.75,0,0,1-.83.54c-5.27,3.07-13.81,3.07-19.08,0h0c-.29-.16-.56-.35-.84-.54s-.3-.23-.45-.35-.13-.09-.19-.15-.38-.33-.56-.5l-.25-.25Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.75,218.07c-6.4-6.61-10.17-33.51-3.92-38.76h31.79c6.25,5.24,2.49,32.14-3.91,38.75l-.18.18-.22.22a7.37,7.37,0,0,1-.58.52l-.15.12c-.16.13-.31.25-.48.37a9.75,9.75,0,0,1-.83.54c-5.27,3.07-13.81,3.07-19.08,0h0c-.29-.16-.56-.35-.84-.54s-.3-.23-.45-.35-.13-.09-.19-.15-.38-.33-.56-.5l-.25-.25Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.86,177.2c7.25,4.24,7.25,11.1,0,15.34s-19,4.23-26.27,0-7.25-11.1,0-15.34S237.61,173,244.86,177.2Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.86,177.2c7.25,4.24,7.25,11.1,0,15.34s-19,4.23-26.27,0-7.25-11.1,0-15.34S237.61,173,244.86,177.2Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.37,179.24c5.33,3.11,5.33,8.15,0,11.26s-14,3.11-19.29,0-5.33-8.15,0-11.26S236.05,176.13,241.37,179.24Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.08,184.58c5.33-3.11,14-3.11,19.29,0a8.87,8.87,0,0,1,3.19,3,8.78,8.78,0,0,1-3.19,3c-5.32,3.11-14,3.11-19.29,0a8.86,8.86,0,0,1-3.19-3A9,9,0,0,1,222.08,184.58Z",
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M249.35,132.39l-12.71,8.69,12-4.55a21.87,21.87,0,0,1-2.38,9.24s-7.94,3.85-12.25,7.91l10.57-3.32A51.64,51.64,0,0,1,242.87,162c-.91,3.36-4,9.61-5.9,12.84a39.62,39.62,0,0,1-2.91,4.3c-.06.09-.13.17-.2.26-2-1.31-4-2.6-6.12-3.85-1.23-3.12-2.57-10.7-2.82-16.85-.92-23.55,17.69-35.69,32.21-39.18A42.48,42.48,0,0,0,249.35,132.39Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.35,132.39l-12.71,8.69,12-4.55a21.87,21.87,0,0,1-2.38,9.24s-7.94,3.85-12.25,7.91l10.57-3.32A51.64,51.64,0,0,1,242.87,162c-.91,3.36-4,9.61-5.9,12.84a39.62,39.62,0,0,1-2.91,4.3c-.06.09-.13.17-.2.26-2-1.31-4-2.6-6.12-3.85-1.23-3.12-2.57-10.7-2.82-16.85-.92-23.55,17.69-35.69,32.21-39.18A42.48,42.48,0,0,0,249.35,132.39Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.21,132.65a17.59,17.59,0,0,0-3.3,4,34.69,34.69,0,0,0-2.33,4.64,47.93,47.93,0,0,0-2.85,9.95,44,44,0,0,0,1.12,20.47h0a.34.34,0,0,1-.64.2h0a44.47,44.47,0,0,1-.8-20.73,48.13,48.13,0,0,1,3-10,33.79,33.79,0,0,1,2.41-4.62A17.9,17.9,0,0,1,239.21,132.65Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193,139.36l0,0a181.07,181.07,0,0,1,12.06,18.1l12.18,2.35-9.07,1.3,4.61,7.82,12,2.87-9.45,1.24s2.33,9.26,8.94,13.29c3.65,2.23,5.46,2.61,6.61,1.58.8-.72,1.12-5.12,1.89-9s1-10.29-2.45-18.12a24,24,0,0,0-3.68-5.78C218.05,144.8,201.36,139.5,193,139.36Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193,139.36l0,0a181.07,181.07,0,0,1,12.06,18.1l12.18,2.35-9.07,1.3,4.61,7.82,12,2.87-9.45,1.24s2.33,9.26,8.94,13.29c3.65,2.23,5.46,2.61,6.61,1.58.8-.72,1.12-5.12,1.89-9s1-10.29-2.45-18.12a24,24,0,0,0-3.68-5.78C218.05,144.8,201.36,139.5,193,139.36Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.76,164.79a0,0,0,0,1,0,0v0a36.86,36.86,0,0,1,2.5,10.2h0a109.47,109.47,0,0,1-.06,13.28,2.05,2.05,0,0,0,.69-.39c.8-.72,1.12-5.12,1.89-9s1-10.29-2.45-18.12a24,24,0,0,0-3.68-5.78c-8.61-10.2-25.3-15.5-33.63-15.64,12.72,2.49,26.2,11.41,32.68,21.51A25.69,25.69,0,0,1,227.76,164.79Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.72,143.76a49.9,49.9,0,0,1,16.66,12.29,33,33,0,0,1,5.57,8.83A31.48,31.48,0,0,1,230.3,175s0,0,0,0,0,0,0,0a40.43,40.43,0,0,0-2.91-9.88,38.38,38.38,0,0,0-5.35-8.76,44.21,44.21,0,0,0-7.49-7.1,58.94,58.94,0,0,0-8.79-5.47s0,0,0,0S205.7,143.76,205.72,143.76Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269,148.05h0a25.87,25.87,0,0,0-3.08,0A49.21,49.21,0,0,0,254,150.23c-1.44.45-2.88,1-4.3,1.55-.72.29-1.42.6-2.12.93a34.4,34.4,0,0,0-9.4,6.32,21.58,21.58,0,0,0-3.34,4.19l-.37.59h0c-.29.52-.55,1-.81,1.54a29.48,29.48,0,0,0-3.45,14.34c-.07,3.52.9,7.59,1.55,8.29a1.68,1.68,0,0,0,.29.24c1,.7,2.58.41,5.64-1.09,6.15-3,9-11.31,9-11.31l-8.2-1.87,10.75-1.53,4.69-6.5L246,164,256.86,163a161,161,0,0,1,12.08-14.92Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.88,148A49.21,49.21,0,0,0,254,150.23c-1.44.45-2.88,1-4.3,1.55-.72.29-1.42.6-2.12.93a34.4,34.4,0,0,0-9.4,6.32,21.58,21.58,0,0,0-3.34,4.19l-.37.59h0c-.29.52-.55,1-.81,1.54a29.48,29.48,0,0,0-3.45,14.34c-.07,3.52.9,7.59,1.55,8.29a1.68,1.68,0,0,0,.29.24,1.76,1.76,0,0,0,.64.28c-.43-5.48,3-19.13,7.37-24.58,4.55-5.67,15-13.67,28.93-15.87h0A25.36,25.36,0,0,0,265.88,148Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.61,188.51a46.69,46.69,0,0,1,1.45-12,38.82,38.82,0,0,1,4.62-11.19,27.36,27.36,0,0,1,3.91-4.68,38.68,38.68,0,0,1,4.67-3.89A44.79,44.79,0,0,1,258,151.12s0,0,0,0,0,0,0,0a59,59,0,0,0-10.33,6.13,48.25,48.25,0,0,0-4.61,3.83,26.53,26.53,0,0,0-3.92,4.49,38.76,38.76,0,0,0-4.75,11,46.85,46.85,0,0,0-1.7,11.9s0,0,0,0A0,0,0,0,1,232.61,188.51Z",
    style: {
      fill: "#fafafa"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-on-the-couch--inject-11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Couch--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M326.27,272.3h10.15l-1.63,9.9h0a1.83,1.83,0,0,1-1,1.23,5.44,5.44,0,0,1-4.91,0,1.85,1.85,0,0,1-1-1.23h0Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382,242.44h10.15l-1.62,9.9h0a1.86,1.86,0,0,1-1,1.22,5.44,5.44,0,0,1-4.91,0,1.84,1.84,0,0,1-1-1.22h0Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.08,230.19h10.15l-1.62,9.9h0a1.79,1.79,0,0,1-1,1.22,5.38,5.38,0,0,1-4.91,0,1.79,1.79,0,0,1-1-1.22h0Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.71,200.16h10.15l-1.62,9.9h0a1.81,1.81,0,0,1-1,1.22,5.44,5.44,0,0,1-4.91,0,1.81,1.81,0,0,1-1-1.22h0Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243,178.16v47.28A10.93,10.93,0,0,0,247.9,234l4,2.32.07,0a11.12,11.12,0,0,0,6.15,1.05l60.25,31.88a11,11,0,0,0,4.86,8.18l.05,0,4,2.3a2.24,2.24,0,0,0,.37.2l.21.1.06,0a11.16,11.16,0,0,0,7.63.35,8,8,0,0,0,.86-.31.75.75,0,0,1,.13-.06,4.51,4.51,0,0,0,.58-.3l58-33.38a10.92,10.92,0,0,0,4.92-8.52l.08-59.85V155.25a11,11,0,0,0-4.92-8.53l-64.84-37.36a10.17,10.17,0,0,0-9.5.16l-4,2.31a13.09,13.09,0,0,0-5.67,8.48l-3.86,25.33-3.57-2.06a10.68,10.68,0,0,0-10.71,0L247.9,169.64A10.93,10.93,0,0,0,243,178.16Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.85,111.83l4-2.31a10.17,10.17,0,0,1,9.5-.16l64.83,37.36c.29.17.6.39.51.32a11.24,11.24,0,0,1,4.36,7.38c-.36-2.52-2.41-3.43-4.86-2l-4,2.32a10.87,10.87,0,0,1-9.84,0l-64.49-37.2C314.13,116,314.13,113.4,316.85,111.83Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243,178.16v47.28A10.93,10.93,0,0,0,247.9,234l4,2.32.07,0a10.56,10.56,0,0,0,5.77,1.09,9.75,9.75,0,0,0,4-1.13L307.32,210a10.93,10.93,0,0,0,4.92-8.53V154.17a10.91,10.91,0,0,0-4.92-8.53l-3.57-2.06a10.68,10.68,0,0,0-10.71,0L247.9,169.64A10.93,10.93,0,0,0,243,178.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.74,143.58l3.58,2.06c2.71,1.56,2.71,4.12,0,5.68l-45.56,26.31a10.92,10.92,0,0,0-4.93,8.53v47.27c0,3.13-2.22,4.41-4.93,2.85l-4-2.32a10.93,10.93,0,0,1-4.92-8.52V178.16a11,11,0,0,1,4.92-8.53l45.14-26A10.66,10.66,0,0,1,303.74,143.58Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.83,186.16v47.27c0,3.13-2.22,4.41-4.93,2.85l-4-2.32a10.93,10.93,0,0,1-4.92-8.52V178.16a10.1,10.1,0,0,1,1.45-4.85l13.85,8A10.07,10.07,0,0,0,256.83,186.16Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.88,237.41a11.67,11.67,0,0,0,1.8,2.7,20.92,20.92,0,0,0,4.63,3.24c17.31,10,29.8,17.18,47.11,27.18a5.46,5.46,0,0,0,4.92,0l16-9.25,32-18.48a9.25,9.25,0,0,0,0-16.35L347.2,216l-13.85-8-15.05-8.66a10.87,10.87,0,0,0-9.85,0L262.9,225.62a10.56,10.56,0,0,0-4.93,8.17A8.72,8.72,0,0,0,258.88,237.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.42,259.87l-52-30c-1.35-.78-2.46-.14-2.46,1.43v5a5.48,5.48,0,0,0,2.46,4.26l52,30c1.36.78,2.46.14,2.46-1.42v-5A5.42,5.42,0,0,0,312.42,259.87Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.3,174.93l47.07,27.14a10.88,10.88,0,0,1,4.92,8.53v10a10.9,10.9,0,0,1-4.92,8.52L319.8,255.39a10.87,10.87,0,0,1-9.84,0l-47.07-27.15a10.9,10.9,0,0,1-4.92-8.52v-10a10.91,10.91,0,0,1,4.92-8.53l45.57-26.3A10.87,10.87,0,0,1,318.3,174.93Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.88,235.23v21.34a10,10,0,0,0,4.92-1.19l45.57-26.3a10.9,10.9,0,0,0,4.92-8.52v-10a11,11,0,0,0-4.42-8.21c2.2,1.58,2,3.9-.5,5.37l-45.57,26.3A10,10,0,0,1,314.88,235.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310,234.06l-47.07-27.15c-2.71-1.57-2.71-4.11,0-5.68l45.57-26.3a10.87,10.87,0,0,1,9.84,0l47.07,27.14c2.72,1.57,2.72,4.12,0,5.69l-45.57,26.3A10.87,10.87,0,0,1,310,234.06Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M276.35,236.65s3.8,12.16,3.66,16.82c-.16,4.86.88,6.56-.39,11.75-.27,1.13-1.07,3.37-1.29,4.29a1.37,1.37,0,0,0,1.09,1.82c2.06.61,5.88-3,7.9-7.19a128.44,128.44,0,0,0,5.43-14.76,6.67,6.67,0,0,0-.38-3.44,10,10,0,0,0-.82-1.84c-.52-2.16-.51-6.19-.86-9Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.48,254.13a5,5,0,0,1,.43,1.63c0,1-2.48,4-3.43,5.05a7.77,7.77,0,0,0-2,5.36,13.41,13.41,0,0,1-3.95,8.33,21.32,21.32,0,0,1-11.13,6c-5.22,1.14-6.8-1.56-6.8-1.56s-1.38-2.59-.34-3.52S296.48,254.13,296.48,254.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.55,244.1c.16,0,.43,0,.79.51.14.19.87,2.56,1.54,3.83s2.5,3.72,2.6,5.69c-1.5,3.67-5.26,6-6.09,9.52s-1.25,7.65-7.09,11.55-11.51,3.88-13.44,2.55-1.56-3.48,1.61-7.37c3.36-4.13,6.18-13.46,6.18-13.46a32.26,32.26,0,0,0,.87-4,27.12,27.12,0,0,0,0-4,3,3,0,0,1,.41-1.79,3.11,3.11,0,0,1,1.59-.92,13.35,13.35,0,0,1,2.9-.71,4.48,4.48,0,0,1,2.87.59,21.51,21.51,0,0,0,1.71,1.31,2.61,2.61,0,0,0,2.73-.25,2.25,2.25,0,0,0,.94-2.41A5.82,5.82,0,0,0,291.55,244.1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.8,272a8.77,8.77,0,0,0-7.58-5c-5.82-.46-8.08,2.33-9.11,4-1.23,2-2.64,5.65-.33,6.93,2.49,1.38,5.52,1.28,10.45-.69S286.8,272,286.8,272Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.21,254.37a.62.62,0,0,1-.53-.05c-.86-.53-5.53-1.93-8.51.41-.34-.32-.22-.84.3-1.54,3.42-1.79,7.84-.49,8.88.16a.56.56,0,0,1,.16.79A.61.61,0,0,1,287.21,254.37Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.28,258.07a1.82,1.82,0,0,1,.48-1.57,10.87,10.87,0,0,1,8.44.37.56.56,0,0,1,.16.79.61.61,0,0,1-.82.18C284.7,257.33,280.27,256,277.28,258.07Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.25,265.73a3.37,3.37,0,0,1,.92-2.05c3.39-1.67,7.71-.4,8.74.23a.57.57,0,0,1,.16.8.68.68,0,0,1-.3.23.62.62,0,0,1-.53-.05C282.34,264.33,277.19,262.81,274.25,265.73Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.92,261.41a.58.58,0,0,1-.53,0c-.85-.53-5.42-1.89-8.41.33a2,2,0,0,1,.63-1.68,10.87,10.87,0,0,1,8.44.37.58.58,0,0,1-.13,1Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270,250.65s-3.59,14.15-6.7,19.49-4.7,7.92-8.7,11.82c-.87.85-2.82,2.4-3.53,3.09a1.44,1.44,0,0,0,0,2.22c1.49,1.69,8.33,2.63,12.42.07s8.12-8.41,10.61-10.54c.94-.8,1.82-1.62,2.68-2.5s.69-1.74.84-2.75c.07-.5.11-1.85.11-1.85.73-2.37,2.48-6,3.43-8.33Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.1,280.65a5.25,5.25,0,0,1-.33,1.74c-.46.9-4.11,2.64-5.5,3.24A8.16,8.16,0,0,0,268,289.8a14,14,0,0,1-7.46,6.11,22.21,22.21,0,0,1-13.22.72c-5.45-1.26-5.73-4.52-5.73-4.52s-.15-3.06,1.25-3.48S278.1,280.65,278.1,280.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.91,269c.15.08.42.19.53.83,0,.25-.32,2.82-.25,4.31s.7,4.64-.09,6.55c-3.06,2.81-7.66,3.33-10,6.29s-4.59,6.69-11.87,7.77-12.62-1.48-13.85-3.59.07-4,4.81-6.26c5-2.41,11.86-10,11.87-10a33.08,33.08,0,0,0,2.6-3.39,28.36,28.36,0,0,0,1.77-3.83,3.13,3.13,0,0,1,1.18-1.51,3.21,3.21,0,0,1,1.92-.15,14.43,14.43,0,0,1,3.06.61,4.73,4.73,0,0,1,2.45,1.85c.39.64.58,1.4,1,2a2.75,2.75,0,0,0,2.7,1,2.33,2.33,0,0,0,2-1.86A5.55,5.55,0,0,0,277.91,269Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261,293.22a9.15,9.15,0,0,0-4.95-8.08c-5.3-3.05-8.68-1.42-10.4-.3-2.05,1.33-5,4.16-3.41,6.41,1.74,2.42,4.66,3.67,10.2,4S261,293.22,261,293.22Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.22,276.74a.64.64,0,0,1-.48-.28c-.57-.89-4.37-4.3-8.24-3.42-.17-.45.17-.89,1-1.32,4-.16,7.63,3,8.33,4.11a.58.58,0,0,1-.21.82A.65.65,0,0,1,269.22,276.74Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.18,275.8a1.88,1.88,0,0,1,1.14-1.27,11.44,11.44,0,0,1,7.83,4.12.58.58,0,0,1-.21.82.64.64,0,0,1-.86-.19C265.53,278.42,261.92,275.19,258.18,275.8Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.88,281.7a3.56,3.56,0,0,1,1.79-1.53c4-.06,7.48,3.07,8.16,4.13a.58.58,0,0,1-.2.82.64.64,0,0,1-.38.08.61.61,0,0,1-.48-.28C260.16,284,256,280.24,251.88,281.7Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.91,282.38a.6.6,0,0,1-.48-.28c-.57-.88-4.29-4.21-8.11-3.44a2.14,2.14,0,0,1,1.34-1.31,11.48,11.48,0,0,1,7.83,4.12.59.59,0,0,1-.2.83A.64.64,0,0,1,263.91,282.38Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.5,171.64c-6.25,3.81-27.73,13.91-36.69,20.91-2.59,2-3.63,4.88-3.58,11.31.07,8.73,4.39,38.81,4.39,38.81.8,1.75,2.71-1.28,2.71-1.28l35.93-38.46Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.5,171.64c-6.25,3.81-27.73,13.91-36.69,20.91-2.59,2-3.63,4.88-3.58,11.31.07,8.73,4.39,38.81,4.39,38.81.8,1.75,2.71-1.28,2.71-1.28l35.93-38.46Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.8,233.6c8-5.64,35.53-41.87,35.53-41.87h0c-3.07-3.07-4-12.89-4-12.89-1.62,3.62-.72,9.37.13,11.51-2.05,1.49-13.59,9.46-21.59,14.76a10.75,10.75,0,0,0-5,6.34C277.66,219.43,274.77,231.94,274.8,233.6Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.5,171.64h0l41,12.77c-2.68,7.5-3.6,11.41-6.07,15.27s-5.21,8-16.52,12.42c-10.9,4.27-24.13,8.5-26.79,9.5-2,.75-3.24,4.53-4.54,9.45-1.35,5.16-1.78,9.26-7.89,19.81-6,10.34-7.21,12.58-7.21,12.58s-7.92.15-12.75-4.87c0,0,10.22-36.31,12.3-42.83,1.16-3.64,1.34-5.59,6.29-9.28,4.25-3.17,23-15,23-15S303.12,181.42,308.5,171.64Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.5,171.64h0l41,12.77c-2.68,7.5-3.6,11.41-6.07,15.27s-5.21,8-16.52,12.42c-10.9,4.27-24.13,8.5-26.79,9.5-2,.75-3.24,4.53-4.54,9.45-1.35,5.16-1.78,9.26-7.89,19.81-6,10.34-7.21,12.58-7.21,12.58s-7.92.15-12.75-4.87c0,0,10.22-36.31,12.3-42.83,1.16-3.64,1.34-5.59,6.29-9.28,4.25-3.17,23-15,23-15S303.12,181.42,308.5,171.64Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.63,115c-.79-.47-1.14-5.74-.3-9.5s-.9-4.68-1.76-3.5a6.17,6.17,0,0,0-1.06,2.19,10.48,10.48,0,0,0-4.9,2.61c-2.11,2.09-4.59,4.64-3.86,10.21a14.52,14.52,0,0,1-.38,5.54c-3,8.18-13.66,18.42-16.06,29.33-2.22,10,5.61,11,12.45,8,7.86-3.53,22.92-16.9,22.92-16.9l6.53-21.91c-4.15,0-7.24.67-12.75,6-.92.89-4.75,4.16-4.75,4.16a45,45,0,0,1,3.92-7.68",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.15,145.61a47.65,47.65,0,0,1-4,7.25,14.29,14.29,0,0,0,5.13-6Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.11,121.06c-4.5-.42-8.14.28-11.67,3.69-3.25,3.15-6.73,6.47-6.73,6.47-2.33,5.42-4,10.68-5.56,14.39a19.61,19.61,0,0,0,4.18,7.87l18.24-14.65Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.25,121.07c1.26-2-.59-3.94-.59-3.94l3-2V115l0,0-12-.54a14.41,14.41,0,0,0,.11,2.57,18.8,18.8,0,0,1,.09,2.6l1.56.93a1.17,1.17,0,0,0,1.12,0l5.05-2.61C308.32,118.68,308.25,121.07,308.25,121.07Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.57,104.36l21-9.91a1.17,1.17,0,0,1,1.18,0c.26.17,1.34.84,1.64,1a1.12,1.12,0,0,1,.53,1l.68,10.87a2.67,2.67,0,0,1-1.44,2.38l-21,9.91a1.24,1.24,0,0,1-1.11,0c-.3-.17-1.47-.89-1.78-1.09a1.18,1.18,0,0,1-.46-.92c-.17-2.73-.51-8.14-.68-10.87A2.66,2.66,0,0,1,298.57,104.36Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.15,107.57a1.47,1.47,0,0,1-.72,1.19l-19.87,9.39,0,.48-.81-11.57a1.43,1.43,0,0,1,.71-1.17l20.32-9.63h0l-.44.21Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.15,107.57a1.47,1.47,0,0,1-.72,1.19l-19.87,9.39,0,.48-.81-11.57a1.43,1.43,0,0,1,.71-1.17l20.32-9.63h0l-.44.21Z",
    style: {
      fill: "#fff",
      opacity: 0.75
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.64,107.84a1.48,1.48,0,0,1-.72,1.18l-20.33,9.61,0-.48,19.87-9.39a1.47,1.47,0,0,0,.72-1.19l-.78-11.09.44-.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.11,119.65l-.06,0c-.3-.17-1.47-.89-1.78-1.09a1.18,1.18,0,0,1-.46-.92c-.17-2.73-.51-8.14-.68-10.87a2.62,2.62,0,0,1,.73-1.84l1.71,1a2.61,2.61,0,0,0-.74,1.85l.68,10.88A1.11,1.11,0,0,0,300.11,119.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.4,95.45a1.25,1.25,0,0,0-1.08,0l-21,9.92a2.24,2.24,0,0,0-.71.52l-1.72-1a2.47,2.47,0,0,1,.72-.54l21-9.91a1.21,1.21,0,0,1,1.17,0C321,94.62,322,95.24,322.4,95.45Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.28,112.3a.78.78,0,0,0-.41.71.3.3,0,0,0,.47.27.8.8,0,0,0,.41-.71A.3.3,0,0,0,300.28,112.3Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311,115c.63-.52.86-2.15,1.93-3.62,1.24-1.69,4.1-1.25,3.21.12s-1.2,2.61-1.85,6.1-2.05,4-3.61,6v-8.41Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.91,122.73c3.45.91,14.6,5.31,14.6,5.31,2.4,1.88,1.39,6,1.35,10.73-.93,34.3-6.87,49.58-6.87,49.58-13.42,2.94-37.93-5.59-42.49-15.83,4.1-6.23,6.86-15.54,7.44-33.82.43-13.57,6.6-17.67,10.6-17.64A65.83,65.83,0,0,1,339.91,122.73Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.81,94.51a4.88,4.88,0,0,0,0-2.4c-.24-.85-.56-1.67-.77-2.52-.27-1.15-.58-2.3-.92-3.43A16.49,16.49,0,0,1,320,81.28a3,3,0,0,1,.83-2.17,3,3,0,0,1,2.92-.49,8.87,8.87,0,0,1,2.65,1.59,5.53,5.53,0,0,1,1-3.45,3.2,3.2,0,0,1,3.23-1.22c1.12.31,1.89,1.32,2.79,2.06,1.64,1.35,3.8,1.83,5.86,2.36a14.54,14.54,0,0,1,5.95,2.53,9.32,9.32,0,0,1,3.52,7c0,1-.42,3.47-.58,4.79-.25,2-.46,4-.78,5.93-1.64,10-4.91,17.26-15,16.52-3.84-.29-9.2-2.67-10.2-6.85a14.6,14.6,0,0,1-.19-2.19c-.1-1.47-.14-3-.11-4.42A52.88,52.88,0,0,1,322.81,94.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.79,89.52s1.94.07,3,2.6c.89,2.2,1.3,5.67-.86,11-2.28,5.65-4.07,7.42-5.31,9.52-.89,1.51-2.31,4.35-2.31,4.35l.63-6.64.57-4.61s-2.84-.65-3.66-5.26c-.93-5.18.05-5.83.05-5.83Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.27,105.2a1.15,1.15,0,0,0,1.09-.08c.92-.54,1.35-1.7,2.13-2.4,1-.91,4.16-2,5.45,1.3s-1.95,7.64-4.31,8.54c-3.47,1.32-4.73-2.17-4.73-2.17l-1.34,14c-4,6.12-8.29,6.61-12.39,6.32s-3.79-4.1-1.16-6.72l.35-4.56a26.78,26.78,0,0,1-5.62-.12c-3-.7-4.45-3.11-5.13-6.49a45,45,0,0,1-.48-11.87,49.44,49.44,0,0,1,2.3-10.76s1.74-1.58,6.79-1.66c3.57,0,8.07-.3,9.94,1.94a5.11,5.11,0,0,0,3.7,4.26C339.78,101.89,343.67,104.94,344.27,105.2Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.29,91.05c-.74-1.36-3.37-2-4.89-1.78a35.47,35.47,0,0,0-6.16,1.9,14.5,14.5,0,0,1-4.62.77,8.33,8.33,0,0,1-4.3-1.1A5,5,0,0,1,315.38,87a5,5,0,0,1,1.73-3.9,2.06,2.06,0,0,0,1,1.68,6.17,6.17,0,0,0,1.89.72,3.73,3.73,0,0,1-1.25-3.51,4.91,4.91,0,0,1,2.87-3.29c1.2-.34,2.59-.7,5.25,1.5S338.57,83.72,337.29,91.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.36,119.39s6.91-.87,9.38-2a7.92,7.92,0,0,0,3.54-3,10.76,10.76,0,0,1-2.16,3.7c-1.9,2.1-10.9,3.08-10.9,3.08Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.21,101.71a1.37,1.37,0,1,0,1.47-1.32A1.4,1.4,0,0,0,332.21,101.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.1,96.65,336,98.23a1.75,1.75,0,0,0-.71-2.32A1.63,1.63,0,0,0,333.1,96.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.47,110.26,326.6,112a3,3,0,0,0,3.74,2.18A3.2,3.2,0,0,0,332.47,110.26Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.34,114.16a3,3,0,0,1-1.59,0,2.77,2.77,0,0,1,2.95-2.46,2.47,2.47,0,0,1,.77.17A3.15,3.15,0,0,1,330.34,114.16Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320,97l3.24-1a1.61,1.61,0,0,0-2-1.17A1.77,1.77,0,0,0,320,97Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321,100.84a1.38,1.38,0,0,0,1.26,1.52,1.42,1.42,0,1,0-1.26-1.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "328.15 99.25 327.16 108.49 322.53 106.52 328.15 99.25",
    style: {
      fill: "#9a4a4d"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M332.21,276.93V229.65a11,11,0,0,1,4.92-8.53l45.63-26.33a3.25,3.25,0,0,0,0-5.62l-1.12-.64,3.87-25.33a13.09,13.09,0,0,1,5.67-8.48l4-2.31c2.71-1.57,4.92-.29,4.92,2.84V178L400,237.86a10.9,10.9,0,0,1-4.92,8.52l-58,33.39C334.43,281.33,332.21,280.05,332.21,276.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.37,221.65v47.28c0,.1,0,.22,0,.32a11,11,0,0,0,4.86,8.18l.05,0,4,2.3a2.24,2.24,0,0,0,.37.2l.21.1.06,0a2.39,2.39,0,0,0,.39.15,11.42,11.42,0,0,0,7.24.2,8,8,0,0,0,.86-.31c-2.37,1-4.2-.36-4.21-3.19h0V229.65a10.93,10.93,0,0,1,4.92-8.53l8.94-5.16,36.69-21.17a3.25,3.25,0,0,0,0-5.62l-4.07-2.35a10.93,10.93,0,0,0-9.84,0L332.21,208l-8.92,5.15A10.9,10.9,0,0,0,318.37,221.65Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.21,229.65v47.27h0c0,2.83,1.84,4.16,4.21,3.19a8,8,0,0,1-.86.31,11.42,11.42,0,0,1-7.24-.2,2.39,2.39,0,0,1-.39-.15l-.06,0-.21-.1a2.24,2.24,0,0,1-.37-.2l-4-2.3-.05,0a11,11,0,0,1-4.86-8.18c0-.1,0-.22,0-.32V221.65a10.08,10.08,0,0,1,1.44-4.85l13.85,8A10,10,0,0,0,332.21,229.65Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--arm--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M372.87,176c-1.33-10.42-2.44-15.84-3.81-22.83-3.19-16.22-2.44-20.88-14.17-23.93,0,0-4.25,3.74-4.43,13.34-.13,7.25,2,11.24,2,11.24l5,24c-4.33,4-15.43,12.72-18.14,14.15-3.65,1.94-7.7,2.69-11.6,4-2.59.89-5,2-7.54,3.06a1,1,0,0,0-.38.21.78.78,0,0,0-.16.83,1.51,1.51,0,0,0,.58.67,4.85,4.85,0,0,0,4.2.57c1.19-.27,2.21-.9,3.62-.86.27,0,.56.08.45.42a2.44,2.44,0,0,1-.43.64,9.77,9.77,0,0,1-3.94,1.9,16.08,16.08,0,0,1-4.2.6,17,17,0,0,0-3.42.23,2.6,2.6,0,0,0-1,.43c-1.55,1.21.91,2.14,1.41,3,.26.44.72,1.22,1,1.63a3.32,3.32,0,0,0,1.2.76,16.39,16.39,0,0,1,1.61,1.16,7.83,7.83,0,0,0,4.43,1.15,24.84,24.84,0,0,0,3.94-.41A16.79,16.79,0,0,0,336.7,209a22.84,22.84,0,0,0,2.6-2.41c.7-.73,1.39-1.48,2.14-2.18a44.35,44.35,0,0,1,3.86-2.93c1.95-1.13,13.13-6.42,24.34-14.24C374.56,183.79,373.46,180.56,372.87,176Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.51,128c8.31,2.7,10.57,6.21,11.36,8.87,1.15,3.83,2,8.2,3.38,14.67,2,9.68,2.36,13.51,2.36,13.51s-4.58,3.71-16.48,3.56l-4-15.74S345.34,139.1,354.51,128Z",
    style: {
      fill: "#fafafa"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--side-table--inject-11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--side-table--inject-11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--side-table--inject-11"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "366.64 284.72 373.01 281.04 366.64 279.2 366.64 284.72",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "366.64 284.72 373.01 281.04 366.64 279.2 366.64 284.72",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "366.64 284.72 373.01 281.04 366.64 279.2 366.64 284.72",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "366.64 284.72 363.45 282.88 363.45 277.36 366.64 279.2 366.64 284.72",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "366.64 284.72 363.45 282.88 363.45 277.36 366.64 279.2 366.64 284.72",
    style: {
      fill: "#fff",
      opacity: 0.75
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "398.56 297.63 398.56 303.5 444.66 276.89 444.66 271.02 398.56 297.63",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "398.56 297.63 398.56 303.5 444.66 276.89 444.66 271.02 398.56 297.63",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "398.56 297.63 398.56 303.5 444.66 276.89 444.66 271.02 398.56 297.63",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "398.56 303.5 395.37 301.66 395.37 295.79 398.56 297.63 398.56 303.5",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "398.56 303.5 395.37 301.66 395.37 295.79 398.56 297.63 398.56 303.5",
    style: {
      fill: "#fff",
      opacity: 0.75
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "447.85 225.03 401.74 251.64 401.74 299.47 447.85 272.86 447.85 225.03",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "447.85 225.03 401.74 251.64 401.74 299.47 447.85 272.86 447.85 225.03",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "401.74 251.64 360.26 227.69 360.26 275.52 401.74 299.47 401.74 251.64",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "401.74 251.64 360.26 227.69 360.26 275.52 401.74 299.47 401.74 251.64",
    style: {
      fill: "#fff",
      opacity: 0.75
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "360.26 227.69 406.37 201.08 447.85 225.03 401.74 251.64 360.26 227.69",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "360.26 227.69 406.37 201.08 447.85 225.03 401.74 251.64 360.26 227.69",
    style: {
      fill: "#fff",
      opacity: 0.85
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "398.56 268.2 363.45 247.93 363.45 273.68 398.56 293.95 398.56 268.2",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "398.56 268.2 363.45 247.93 363.45 273.68 398.56 293.95 398.56 268.2",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "363.45 273.68 385.6 260.72 398.56 268.2 398.56 293.95 363.45 273.68",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "363.45 273.68 385.6 260.72 363.45 247.93 363.45 273.68",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "398.56 253.48 363.45 233.21 363.45 244.25 398.56 264.52 398.56 253.48",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "398.56 253.48 363.45 233.21 363.45 244.25 398.56 264.52 398.56 253.48",
    style: {
      fill: "#fff",
      opacity: 0.85
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.67,249.52c0,.51-1.52,0-3.39-1L378.33,245c-1.88-1.08-3.4-2.37-3.4-2.88v-.92l12.74,7.36Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--shadow--inject-11",
    style: {
      opacity: 0.1
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-11",
    d: "M424.83,231.29a15.82,15.82,0,0,0,8.66-2.36c2-1.34,3.13-3,3.13-4.73s-1.11-3.39-3.13-4.73a17.09,17.09,0,0,0-17.33,0c-2,1.34-3.13,3-3.13,4.73s1.11,3.39,3.13,4.73A15.83,15.83,0,0,0,424.83,231.29Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Lamp--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M417.08,223.63a3.15,3.15,0,0,1,.06-.61,9.22,9.22,0,0,1,3.74-5.58h7.83a9.22,9.22,0,0,1,3.74,5.58,3.18,3.18,0,0,1,.06.62s0,.1,0,.1a3.94,3.94,0,0,1-2.25,3,12.05,12.05,0,0,1-10.91,0,3.94,3.94,0,0,1-2.25-3A1,1,0,0,1,417.08,223.63Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.5,217.31c2.05,1.19,2.05,3.1,0,4.29a8.22,8.22,0,0,1-7.42,0c-2-1.19-2-3.1,0-4.29A8.22,8.22,0,0,1,428.5,217.31Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.73,191.21h2.13v27.43h0a.48.48,0,0,1-.3.48,1.67,1.67,0,0,1-1.51,0,.48.48,0,0,1-.3-.48h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.06,187.1h0l7.41-18.89h16.66l7.41,18.89h0c1.05,3-.4,6.15-4.37,8.45-6.28,3.62-16.45,3.62-22.73,0C409.46,193.25,408,190.06,409.06,187.1Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.82,172.73a13.32,13.32,0,0,1-12.05,0c-3.33-1.92-3.33-5,0-7a13.32,13.32,0,0,1,12.05,0C434.15,167.69,434.15,170.81,430.82,172.73Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.82,172.73a13.32,13.32,0,0,1-12.05,0c-3.33-1.92-3.33-5,0-7a13.32,13.32,0,0,1,12.05,0C434.15,167.69,434.15,170.81,430.82,172.73Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.79,173.19a11.32,11.32,0,0,0,5.54-1.31c1.29-.75,2-1.68,2-2.63a3.32,3.32,0,0,0-2-2.62,12.35,12.35,0,0,0-11.07,0,3.32,3.32,0,0,0-2,2.62c0,.95.71,1.88,2,2.63A11.3,11.3,0,0,0,424.79,173.19Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.79,173.19a11.32,11.32,0,0,0,5.54-1.31c1.29-.75,2-1.68,2-2.63a3.32,3.32,0,0,0-2-2.62,12.35,12.35,0,0,0-11.07,0,3.32,3.32,0,0,0-2,2.62c0,.95.71,1.88,2,2.63A11.3,11.3,0,0,0,424.79,173.19Z",
    style: {
      opacity: 0.15
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Icons--inject-11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--call-icon--inject-11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Box--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M450.49,100.66,419.13,82.55a1.81,1.81,0,0,0-1.85-.17l-4,2.33a1.82,1.82,0,0,0-.77,1.69V132a5.74,5.74,0,0,0,2.6,4.5l31.36,18.11a1.83,1.83,0,0,0,1.85.17l4.05-2.34a1.82,1.82,0,0,0,.76-1.68V105.16A5.73,5.73,0,0,0,450.49,100.66Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.09,105.16v45.59a1.85,1.85,0,0,1-.76,1.69l-3.93,2.26a1.91,1.91,0,0,0,.63-1.6V107.5a5.35,5.35,0,0,0-.76-2.56l4.06-2.34A5.29,5.29,0,0,1,453.09,105.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.07,136.49l31.36,18.11c1.44.82,2.6.15,2.6-1.5V107.51a5.71,5.71,0,0,0-2.6-4.5L415.07,84.9c-1.44-.83-2.6-.16-2.6,1.5V132A5.77,5.77,0,0,0,415.07,136.49Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.33,102.6l-4.06,2.34a5.38,5.38,0,0,0-1.84-1.94L415.07,84.9a1.92,1.92,0,0,0-1.72-.25c.73-.42,3.5-2,3.93-2.27a1.82,1.82,0,0,1,1.85.18l31.36,18.1A5.22,5.22,0,0,1,452.33,102.6Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--call-icon--inject-11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--g4780--inject-11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--g15--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--path17-6--inject-11",
    d: "M439.34,132.2c-.69-1.25-1.43-2.45-2.16-3.65-1.44-2.4-2.77-3.29-3.85-1.39a2,2,0,0,1-3.27,0,29.61,29.61,0,0,1-5.45-11.33c-.49-2,.44-4,1.58-4.55a1.85,1.85,0,0,0,1.17-2.09c-.06-1.85-2.91-9.54-4-10.82a2,2,0,0,0-1.4-.82c-2.64-.15-5.8,3.13-4.75,7.69,3.12,13.61,5.7,20.77,14.41,32.14,3.71,4.88,8.47,2.2,9.32.29.56-2.12-.62-3.77-1.56-5.48Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--path19-1--inject-11",
    d: "M432.49,102.78c5.53,4.51,8.08,10,8.79,19,.06.83-.13,1.91.61,2.36s.58-.82.59-1.61c-.14-9.22-3.88-17.76-9.83-21.52-.36-.22-1.23-1.14-1.28.21,0,.92.66,1.17,1.12,1.54Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--path21-2--inject-11",
    d: "M432.77,106.2c-.53-.4-1.24-1.2-1.36-.13s.65,1.45,1.16,1.91c3.41,3.15,4.6,5.75,5.17,11.3.08.81-.09,1.9.75,2.18.63.22.4-.93.45-1.49,0-5-2.76-11.17-6.17-13.77Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--path23--inject-11",
    d: "M432.25,110.73c-.36-.19-.7-.34-.83.17a1.43,1.43,0,0,0,.63,1.56,6.77,6.77,0,0,1,2.28,5.08c0,.61.28,1.22.65,1.37s.55-.47.53-1.14c0-2.41-1.75-6.23-3.26-7Z",
    style: {
      fill: "#fafafa"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Gears--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M452.06,81.28l-1.79-4a1.67,1.67,0,0,0-.89-.75,10.4,10.4,0,0,1-1.37-.56.32.32,0,0,0-.25,0,.23.23,0,0,0-.14.16l-.9,2.4a1.11,1.11,0,0,1-.75.71,1.08,1.08,0,0,1-1-.29l-3.1-2.79a2.29,2.29,0,0,1-.69-1.86l.4-3.1a1.9,1.9,0,0,0-.32-1.19c-.49-.68-1-1.4-1.41-2.15a1.2,1.2,0,0,0-.87-.52l-2.12,0a1.83,1.83,0,0,1-1.61-1.14l-1.69-4.57a1.34,1.34,0,0,1,.05-1,1.28,1.28,0,0,1,.77-.69l1.75-.61a.58.58,0,0,0,.33-.6c-.11-.74-.19-1.48-.23-2.19a2.08,2.08,0,0,0-.48-1.17L433,52.36a2.2,2.2,0,0,1-.51-1.92l.75-3.13a1,1,0,0,1,1.66-.59l2.78,2.1a.36.36,0,0,0,.5-.1,5.6,5.6,0,0,1,.66-.71,1,1,0,0,0,.29-.86L438,43.06a1.23,1.23,0,0,1,.13-1,1.27,1.27,0,0,1,.87-.56l2.22-.34a1.69,1.69,0,0,1,1.73.94l1.79,4a1.68,1.68,0,0,0,.88.75,10,10,0,0,1,1.38.56.32.32,0,0,0,.25,0,.28.28,0,0,0,.14-.16l.9-2.4a1.11,1.11,0,0,1,.75-.71,1.09,1.09,0,0,1,1,.29l3.1,2.79a2.29,2.29,0,0,1,.69,1.86l-.4,3.1a1.9,1.9,0,0,0,.32,1.19c.49.68,1,1.4,1.41,2.15a1.18,1.18,0,0,0,.87.52l2.12,0a1.83,1.83,0,0,1,1.61,1.14l1.69,4.57a1.34,1.34,0,0,1,0,1,1.31,1.31,0,0,1-.77.69l-1.75.61a.59.59,0,0,0-.34.6,19,19,0,0,1,.23,2.19,2.23,2.23,0,0,0,.48,1.17L461.93,71a2.27,2.27,0,0,1,.51,1.92L461.69,76a1,1,0,0,1-.66.78,1.06,1.06,0,0,1-1-.19l-2.77-2.1a.37.37,0,0,0-.5.1,6.37,6.37,0,0,1-.66.71,1,1,0,0,0-.29.86L457,80.29a1.23,1.23,0,0,1-.13,1,1.27,1.27,0,0,1-.87.56l-2.22.34-.22,0A1.71,1.71,0,0,1,452.06,81.28Zm5.78-7.53,2.78,2.1.08.05s0,0,0-.1l.76-3.12a1.3,1.3,0,0,0-.27-1l-2.73-2.86a3.13,3.13,0,0,1-.75-1.8,17.27,17.27,0,0,0-.22-2.09,1.54,1.54,0,0,1,1-1.67l1.75-.62a.32.32,0,0,0,.2-.18.34.34,0,0,0,0-.28l-1.68-4.57a.91.91,0,0,0-.71-.5l-2.11,0a2.17,2.17,0,0,1-1.71-1A23.1,23.1,0,0,0,452.9,54a3,3,0,0,1-.5-1.9l.4-3.1a1.33,1.33,0,0,0-.37-1l-3.1-2.79c-.06-.05-.09-.06-.1-.06a.34.34,0,0,0-.06.1l-.9,2.4a1.2,1.2,0,0,1-.69.72,1.25,1.25,0,0,1-1.05,0,11.74,11.74,0,0,0-1.25-.51,2.59,2.59,0,0,1-1.48-1.28L442,42.47a.71.71,0,0,0-.68-.37l-2.22.34a.31.31,0,0,0-.19.12.27.27,0,0,0,0,.22l1.22,4.09a1.93,1.93,0,0,1-.57,1.86,6.32,6.32,0,0,0-.56.6,1.33,1.33,0,0,1-1.87.27l-2.77-2.1-.08,0a.29.29,0,0,0,0,.1l-.76,3.12h0a1.3,1.3,0,0,0,.27,1l2.73,2.86a3.13,3.13,0,0,1,.75,1.8,17.06,17.06,0,0,0,.22,2.09,1.55,1.55,0,0,1-1,1.67l-1.75.62a.32.32,0,0,0-.2.18.34.34,0,0,0,0,.28l1.68,4.56a.88.88,0,0,0,.71.51l2.11,0a2.19,2.19,0,0,1,1.71,1,23.1,23.1,0,0,0,1.36,2.07,3,3,0,0,1,.5,1.9l-.4,3.1a1.33,1.33,0,0,0,.37,1l3.1,2.79a.22.22,0,0,0,.09.06s0,0,.06-.1l.91-2.4a1.17,1.17,0,0,1,.69-.72,1.22,1.22,0,0,1,1,.05,12.8,12.8,0,0,0,1.26.51,2.62,2.62,0,0,1,1.48,1.28l1.79,4a.71.71,0,0,0,.68.37l2.22-.34a.25.25,0,0,0,.21-.34l-1.22-4.09a1.93,1.93,0,0,1,.57-1.86A5.4,5.4,0,0,0,456,74a1.4,1.4,0,0,1,1.08-.53A1.27,1.27,0,0,1,457.84,73.75Zm-12.29-5h0c-3.48-3.12-5.56-8.79-4.64-12.63a4.32,4.32,0,0,1,2.79-3.36c1.7-.53,3.78.17,5.72,1.92,3.48,3.12,5.56,8.79,4.64,12.63a4.32,4.32,0,0,1-2.79,3.36,4.07,4.07,0,0,1-1.16.17A7.07,7.07,0,0,1,445.55,68.71Zm-1.56-15a3.33,3.33,0,0,0-2.12,2.65C441,59.83,443,65.07,446.2,68c1.68,1.51,3.42,2.13,4.78,1.71A3.33,3.33,0,0,0,453.1,67c.85-3.52-1.1-8.76-4.34-11.67a6.14,6.14,0,0,0-3.89-1.84A2.84,2.84,0,0,0,444,53.66Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.8,71l-1.29-2.91a1.09,1.09,0,0,0-.58-.49,9.17,9.17,0,0,1-1-.41s-.08,0-.16,0L420.12,69a.81.81,0,0,1-1.37.33l-2.23-2a1.75,1.75,0,0,1-.52-1.4l.29-2.23a1.41,1.41,0,0,0-.22-.79c-.36-.5-.7-1-1-1.55a.82.82,0,0,0-.55-.34L413,61a1.41,1.41,0,0,1-1.23-.88l-1.21-3.28a1,1,0,0,1,0-.8,1,1,0,0,1,.6-.54l1.26-.44a.31.31,0,0,0,.18-.34,14.58,14.58,0,0,1-.16-1.58,1.4,1.4,0,0,0-.32-.78l-2-2a1.72,1.72,0,0,1-.38-1.46l.54-2.24a.8.8,0,0,1,1.32-.47l2,1.5a.17.17,0,0,0,.24-.06,4.78,4.78,0,0,1,.49-.51.6.6,0,0,0,.18-.53l-.87-2.94a1,1,0,0,1,.11-.81,1,1,0,0,1,.68-.44l1.59-.24a1.28,1.28,0,0,1,1.33.72l1.29,2.91a1.09,1.09,0,0,0,.58.49,9.06,9.06,0,0,1,1,.4s.08,0,.16-.05l.65-1.72a.87.87,0,0,1,.59-.56.88.88,0,0,1,.79.22l2.22,2a1.71,1.71,0,0,1,.52,1.4l-.28,2.23a1.33,1.33,0,0,0,.21.79c.36.49.7,1,1,1.55a.82.82,0,0,0,.55.34l1.52,0a1.41,1.41,0,0,1,1.23.88L430.65,57a1,1,0,0,1-.63,1.35l-1.26.44a.32.32,0,0,0-.19.33,12.64,12.64,0,0,1,.17,1.59,1.51,1.51,0,0,0,.32.78l2,2a1.74,1.74,0,0,1,.39,1.45l-.54,2.25a.86.86,0,0,1-.53.62.85.85,0,0,1-.8-.15l-2-1.5c-.09-.08-.2,0-.24.06a4.74,4.74,0,0,1-.49.51.6.6,0,0,0-.18.53l.87,2.94a1,1,0,0,1-.1.81,1,1,0,0,1-.69.43l-1.59.25H425A1.32,1.32,0,0,1,423.8,71Zm4.28-5.51L430,67.05l.54-2.25a.81.81,0,0,0-.18-.64l-1.95-2.06a2.28,2.28,0,0,1-.56-1.34,13.27,13.27,0,0,0-.16-1.49,1.21,1.21,0,0,1,.76-1.29l1.26-.44a.18.18,0,0,0,.1-.09.19.19,0,0,0,0-.13L428.62,54a.56.56,0,0,0-.43-.31l-1.51,0a1.66,1.66,0,0,1-1.29-.76,17.24,17.24,0,0,0-1-1.48,2.19,2.19,0,0,1-.37-1.42l.29-2.23a.94.94,0,0,0-.24-.64l-2.2-2-.65,1.72a.94.94,0,0,1-.55.57,1,1,0,0,1-.81,0,9.22,9.22,0,0,0-.89-.36,1.94,1.94,0,0,1-1.11-1l-1.29-2.9a.42.42,0,0,0-.4-.22l-1.59.25-.06-.43,0,.56.87,2.94a1.47,1.47,0,0,1-.43,1.42,5.33,5.33,0,0,0-.4.42,1,1,0,0,1-1.45.21l-1.94-1.53-.54,2.25h0a.83.83,0,0,0,.18.64l1.95,2a2.37,2.37,0,0,1,.56,1.35c0,.48.08,1,.16,1.49a1.2,1.2,0,0,1-.76,1.29l-1.26.44a.18.18,0,0,0-.1.09.19.19,0,0,0,0,.13l1.21,3.28a.53.53,0,0,0,.43.3l1.51,0a1.7,1.7,0,0,1,1.3.76,16.39,16.39,0,0,0,1,1.48,2.19,2.19,0,0,1,.37,1.42L416.86,66a.94.94,0,0,0,.24.64l2.21,2L420,67a1,1,0,0,1,.55-.57,1,1,0,0,1,.82,0,8.15,8.15,0,0,0,.88.36,1.94,1.94,0,0,1,1.11,1l1.29,2.9a.43.43,0,0,0,.4.22l1.59-.25.08-.13-.87-2.94a1.46,1.46,0,0,1,.43-1.42,5.33,5.33,0,0,0,.4-.42,1,1,0,0,1,.83-.42A1,1,0,0,1,428.08,65.52ZM419.15,62h0c-2.52-2.26-4-6.36-3.35-9.14a3.16,3.16,0,0,1,2.06-2.47c1.24-.39,2.77.12,4.18,1.39,2.52,2.26,4,6.36,3.35,9.14a3.17,3.17,0,0,1-2.05,2.47,2.8,2.8,0,0,1-.86.13A5.18,5.18,0,0,1,419.15,62Zm-1-10.78a2.31,2.31,0,0,0-1.46,1.84c-.6,2.5.78,6.22,3.08,8.29h0c1.18,1.06,2.4,1.5,3.35,1.21a2.33,2.33,0,0,0,1.46-1.84c.6-2.5-.78-6.22-3.08-8.29a4.34,4.34,0,0,0-2.74-1.3A2.1,2.1,0,0,0,418.11,51.26Z",
    style: {
      fill: "#06EB83"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Wrench--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M396,122.58a4.33,4.33,0,0,1-2.2-.66l-.27-.17a.78.78,0,0,1-.23-1l2.5-5-1.28-4.22-2.29-1.35L390,114.72a.46.46,0,0,1-.47.26c-.45,0-.79-.76-.9-1.19a15.83,15.83,0,0,1-.53-4.08c0-3.37,1.25-5.69,3.24-6.18v-25a17.16,17.16,0,0,1-3.24-9.87c0-2.85.91-5,2.45-5.86a3.66,3.66,0,0,1,3.75.25l.27.17a.81.81,0,0,1,.23,1l-2.5,5,1.28,4.22,2.29,1.35,2.27-4.56a.46.46,0,0,1,.47-.26c.45,0,.79.76.9,1.2a16.25,16.25,0,0,1,.53,4.07c0,3.37-1.25,5.69-3.24,6.18v25a17.23,17.23,0,0,1,3.24,9.87c0,2.85-.91,5-2.45,5.86A3.12,3.12,0,0,1,396,122.58ZM392,109.11l3.23,1.91,1.46,4.78L394,121.08a.55.55,0,0,0,.21.19,2.9,2.9,0,0,0,3,.25c1.28-.73,2-2.68,2.07-5.22a16.42,16.42,0,0,0-3.16-9.5l-.08-.11V80.83l.32,0c1.76-.25,2.9-2.41,2.92-5.51a15.74,15.74,0,0,0-.51-3.88,1.75,1.75,0,0,0-.16-.41l-2.44,4.9L392.94,74l-1.45-4.78,2.63-5.29a.5.5,0,0,0-.2-.18,2.9,2.9,0,0,0-3-.25c-1.28.73-2.06,2.68-2.07,5.22A16.28,16.28,0,0,0,392,78.2l.08.1v25.87l-.33,0c-1.75.25-2.9,2.41-2.91,5.51h0a15.2,15.2,0,0,0,.5,3.88,1.75,1.75,0,0,0,.16.41Z",
    style: {
      fill: "#06EB83"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubbles--inject-11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M254.05,48.65l36.56,21.1a1.64,1.64,0,0,1,.74,1.28v25.6a1.63,1.63,0,0,1-.74,1.27L288,99.41a1.62,1.62,0,0,1-1.47,0L249.94,78.3a1.66,1.66,0,0,1-.73-1.28V51.38a1.59,1.59,0,0,1,.74-1.26l2.63-1.48A1.62,1.62,0,0,1,254.05,48.65Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.24,99V73.34a1.64,1.64,0,0,0-.74-1.28L249.94,51c-.4-.24-.73-.05-.73.42V77a1.66,1.66,0,0,0,.73,1.28L286.5,99.4C286.91,99.64,287.24,99.45,287.24,99Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.24,99V73.34a1.64,1.64,0,0,0-.74-1.28L249.94,51c-.4-.24-.73-.05-.73.42V77a1.66,1.66,0,0,0,.73,1.28L286.5,99.4C286.91,99.64,287.24,99.45,287.24,99Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.5,99.4a1.67,1.67,0,0,0,1.48,0l2.63-1.51a1.63,1.63,0,0,0,.74-1.27V71a1.41,1.41,0,0,0-.24-.75L287,72.61a1.54,1.54,0,0,1,.22.73V99C287.24,99.41,286.93,99.65,286.5,99.4Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.22,51.25c.06-.37.36-.5.72-.29l36.56,21.1a1.53,1.53,0,0,1,.52.55l4.1-2.33a1.45,1.45,0,0,0-.51-.53l-36.56-21.1a1.62,1.62,0,0,0-1.47,0L250,50.11A1.63,1.63,0,0,0,249.22,51.25Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.36,89.68l4-2.28a.68.68,0,0,0,.14-1.05l-6.25-7.8-4,2.3,6.24,7.8A.69.69,0,0,1,293.36,89.68Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.36,89.68l4-2.28a.68.68,0,0,0,.14-1.05l-6.25-7.8-4,2.3,6.24,7.8A.69.69,0,0,1,293.36,89.68Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.24,80.85l6.25,7.8a.66.66,0,0,1-.42,1.13l-5.83.63Z",
    style: {
      fill: "#06EB83"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M278.45,77c0,1-.72,1.34-1.6.82L256.54,66.12a3.53,3.53,0,0,1-1.6-2.72c0-1,.72-1.34,1.6-.82L276.85,74.3A3.53,3.53,0,0,1,278.45,77Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283,87.5c0,1-.72,1.34-1.6.82L256.54,74a3.53,3.53,0,0,1-1.6-2.72c0-1,.72-1.34,1.6-.82l24.84,14.33A3.53,3.53,0,0,1,283,87.5Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127,127.17,123,119.79l3.16-9.12v-5.59l-9.67,5.59v5.58l4.15,7.2a.59.59,0,0,0,.29.25h0Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127,127.17,123,119.79l3.16-9.12v-5.59l-9.67,5.59v5.58l4.15,7.2a.59.59,0,0,0,.29.25h0Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152,71.26a6.43,6.43,0,0,0-2.9-5l-2.36-1.36a6.38,6.38,0,0,0-5.8,0L94.8,91.51a6.4,6.4,0,0,0-2.9,5v28.28a6.4,6.4,0,0,0,2.9,5l2.36,1.37a6.44,6.44,0,0,0,5.8,0l19.64-11.43,4.15,7.18a.62.62,0,0,0,1.12-.1l4.38-12.66,16.83-9.62a6.43,6.43,0,0,0,2.9-5Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.9,124.81a6.4,6.4,0,0,0,2.9,5l2.36,1.37a6.51,6.51,0,0,0,5.3.23c-1.36.52-2.4-.25-2.4-1.91V101.24a5.83,5.83,0,0,1,.85-2.85l-8.16-4.72a5.9,5.9,0,0,0-.85,2.86Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.89,70.44c-.34-1.23-1.46-1.62-2.8-.85L103,96.22a5.81,5.81,0,0,0-2,2.17l-8.15-4.71a5.76,5.76,0,0,1,2-2.16l46.12-26.64a6.44,6.44,0,0,1,5.8,0l2.37,1.37A6.42,6.42,0,0,1,151.89,70.44Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M111.84,104.12a8.53,8.53,0,0,0-3.87,6.7c0,2.47,1.73,3.47,3.87,2.23a8.53,8.53,0,0,0,3.87-6.7C115.71,103.88,114,102.88,111.84,104.12Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.1,95.87a8.56,8.56,0,0,0-3.87,6.7c0,2.46,1.74,3.46,3.87,2.23A8.53,8.53,0,0,0,130,98.1C130,95.63,128.24,94.63,126.1,95.87Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.37,87.61a8.56,8.56,0,0,0-3.87,6.7c0,2.47,1.73,3.47,3.87,2.24a8.56,8.56,0,0,0,3.87-6.7C144.24,87.38,142.51,86.38,140.37,87.61Z",
    style: {
      fill: "#fafafa"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssistance);
export default __webpack_public_path__ + "static/media/Assistance.eafc7b97f1cebd19756f87b86347fe5a.svg";
export { ForwardRef as ReactComponent };